<template>
  <div id="app">
    <template v-if="isMaintencanceMode">
      <Maintenance/>
    </template>
    <Experts v-else-if="isExpertsRoute">
      <router-view/>
    </Experts>
    <Default v-else>
      <router-view/>
    </Default>
  </div>
</template>

<script>
import isTokenExpired from './services/auth.isTokenExpired';
import Default from './layouts/Default.vue';
import Experts from './layouts/Experts.vue';
import Maintenance from './views/Maintenance.vue';

export default {
  components: {
    Default,
    Experts,
    Maintenance,
  },
  data() {
    return {
      isMaintencanceMode: /^true$/i.test(process.env.VUE_APP_MAINTENANCE),
      isExpertsRoute: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.user.status.loggedIn;
    },
  },
  watch: {
    $route: {
      // eslint-disable-next-line
      handler: function (route) {
        this.isExpertsRoute = route.name === 'Experts';
      },
      deep: true,
      immediate: true,
    },
    // eslint-disable-next-line
    '$i18n.locale'(newLang) {
      this.toggleRaffleScript(newLang);
    },
  },
  created() {
    // Handle $fromApp global variable
    const urlParams = new URLSearchParams(window.location.search);
    const fromAppParam = urlParams.get('fromApp');
    if (fromAppParam) {
      this.$fromApp = fromAppParam;
    }
  },
  methods: {
    toggleRaffleScript(lang) {
      const existingScript = document.getElementById('raffle-sdk-v2');

      let raffleWidgetUid = '';

      if (lang === 'pl') {
        raffleWidgetUid = '3058447b-859f-4fb5-a5d6-141b11c7fad2';
      } else if (lang === 'nl') {
        raffleWidgetUid = 'aec978dd-b68b-4c32-a9d1-26c27ac30a1f';
      } else if (lang === 'de') {
        raffleWidgetUid = 'dad0c3d3-d4c3-45c2-80d4-ae543964ce6c';
      } else if (lang === 'it') {
        raffleWidgetUid = 'd066d46f-751b-4d4a-a734-c2bb44e736a4';
      } else if (lang === 'fr') {
        raffleWidgetUid = 'e68077ee-4367-43ed-84c6-7dc341b5c79c';
      } else if (lang === 'da') {
        raffleWidgetUid = 'd151e073-e145-4a9c-b9d1-7898ad6a18bc';
      } else {
        raffleWidgetUid = '254f4a2b-b56a-4c03-a5a5-a2047077e256'; // ENG
      }

      if (!existingScript) {
        const script = document.createElement('script');
        script.innerHTML = `
          (function() {
            var el = document.createElement("script");
            el.setAttribute("src", "https://cdn.raffle.ai/search-v2/index.js");
            el.setAttribute("id", "raffle-sdk-v2");
            el.setAttribute("defer", "");
            el.setAttribute("data-uid", "${raffleWidgetUid}");
            el.setAttribute("type", "module");
            document.head.appendChild(el);
          })();
        `;
        script.id = 'raffle-injector';
        document.head.appendChild(script);
      }
    },
  },
  mounted() {
    this.$cookiebot.consentBanner();
    if (this.loggedIn && isTokenExpired()) {
      this.$store.dispatch('user/LOGOUT');
    }

    window.addEventListener('CookiebotOnAccept', () => {
      // eslint-disable-next-line
      if (Cookiebot.consent.marketing) {
        // eslint-disable-next-line
        window._paq.push(['trackEvent', 'Cookie', 'Consent', 'Marketing']);
      }
      // eslint-disable-next-line
      if (Cookiebot.consent.preferences) {
        // eslint-disable-next-line
        window._paq.push(['trackEvent', 'Cookie', 'Consent', 'Preferences']);
      }
      // eslint-disable-next-line
      if (Cookiebot.consent.statistics) {
        // eslint-disable-next-line
        window._paq.push(['trackEvent', 'Cookie', 'Consent', 'Statistics']);
      }
    }, false);

    // Raffle.ai — wait for initial navigation: vue-lang-router sets the real
    // locale asynchronously in beforeEach, before that it's always 'en'.
    this.$router.onReady(() => {
      this.toggleRaffleScript(this.$i18n.locale);
    });
  },
};
</script>
